export const FAQ_OVERVIEW_URL = 'https://help.zenbusiness.com/zenbusiness-banking';

export const FAQ_PAYEES_URL = 'https://help.zenbusiness.com/ZenBusiness_Banking/Sending_Money';

export const FAQ_CHECK_HISTORY_URL =
  'https://help.zenbusiness.com/ZenBusiness_Banking/Depositing_Money';

export const SUBJECT_TO_REVIEW_URL =
  'https://help.zenbusiness.com/ZenBusiness_Banking/Depositing_Money/Reviews_of_Transfers_Into_and_Out_of_ZenBusiness';

export const OWNER_CONTRIBUTIONS_URL = 'https://www.zenbusiness.com/blog/owners-contributions/';
